import { Dropdown } from 'semantic-ui-react';
import { useWarehouseOptions } from 'hooks/useWarehouseOptions';

export default function WarehousesDropdown({
  warehouses,
  value,
  onChange = () => {},
  ...props
}) {
  const warehouseOptions = useWarehouseOptions(warehouses);

  return (
    <Dropdown
      search
      placeholder="Almacén"
      fluid
      selection
      options={warehouseOptions}
      closeOnChange
      noResultsMessage="No hay coincidencias"
      selectOnBlur={false}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
}
